enum AvatarTypes {
  service = 'service',
  people = 'people',
  shop = 'shop'
}

export interface Avatar {
  _id: string;
  avatar_index: number;
  name: string;
  type: AvatarTypes;
  url: string;
}

export interface State {
  avatars: Avatar[];
  isLoading: boolean;
}

export enum ActionTypes {
  GET_AVATARS = 'GET_AVATARS',
  GET_AVATARS_SUCCESS = 'GET_AVATARS_SUCCESS',
  GET_AVATARS_FAILURE = 'GET_AVATARS_FAILURE'
}
